import { api as locationPageApi }    from '../locationPageActions';
import {api as gridApi} from '../ShipmentsView/shipmentsGridActions';
import  * as shipmentsService      from '../../../services/Shipments/shipmentsService';
import Network from "infrastructure/js/modules/network";
import {api as messageDialogApi} from "../../MessageDialog/messageDialogActions";
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import MessageDialog from 'infrastructure/js/components/Dialog/MessageDialog/messageDialog';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.reload = function(shouldRefreshGrid) {
  return function(dispatch, getState) {
    api.init(dispatch, getState)(shouldRefreshGrid);
  }
};

jsxActions.getLocationDetails = function() {
  return function(dispatch, getState) {
    return locationPageApi.getLocationDetails(dispatch, getState)();
  };
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  }
};

jsxActions.shipmentReadyToShip = function (data) {
  return function (dispatch, getState) {
    api.shipmentReadyToShip(dispatch, getState)(data);
  }
};

jsxActions.markShipmentAsReceived = function (data) {
  return function (dispatch, getState) {
    api.markShipmentAsReceived(dispatch, getState)(data);
  }
};

jsxActions.deleteShipment = function (data) {
  return function (dispatch, getState) {
    api.deleteShipmentConfirmationDialog(dispatch, getState)(data);
  }
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.init = function(dispatch, getState) {
  return function(shouldRefreshGrid) {
    if (shouldRefreshGrid) {
      gridApi.reload(dispatch, getState)();
    }
  }
};
api.shipmentReadyToShip = function(dispatch, getState) {
  return function({selectedRowsData, reloadParentComponent}) {

    let locationId = locationPageApi.getLocationId(dispatch, getState)();
    let shipmentId = selectedRowsData?.get(0)?.id || null;

    shipmentsService.shipmentReadyToShip(shipmentId, locationId).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Shipment ready to ship failed', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }

      if (reloadParentComponent) {
        reloadParentComponent();
      }

      return {success: true};
    });
  }
};

api.markShipmentAsReceived = function (dispatch, getState) {
  return function ({ selectedRowsData, skipExternalSensors = true, reloadParentComponent, successCallback }) {
    let locationId = locationPageApi.getLocationId(dispatch, getState)();
    let shipmentId = selectedRowsData?.get(0)?.id || null;
    gridApi.setBusy(true)(dispatch, getState);

    return shipmentsService
      .markShipmentAsReceived(shipmentId, locationId, skipExternalSensors)
      .then((response) => {
        gridApi.setBusy(false)(dispatch, getState);

        if (!Network.isResponseValid(response)) {
          console.error('Mark shipment as received failed', response);
          const errorCode = response?.applicationResponseStatus?.errorCode;
          const truckSensorIntegrationErrorFlow =
            PermissionManager.isTruckSensorsIntegrationEnabled() && selectedRowsData?.get?.(0)?.truckSensorsEnabled && errorCode !== 'MAT_5545014';

          if (truckSensorIntegrationErrorFlow) {

            const retryFunc = () =>
              api.markShipmentAsReceived(
                dispatch,
                getState
              )({ selectedRowsData, skipExternalSensors: false, reloadParentComponent, successCallback });

            const closeFunc = (shouldSendNotification = true) => {
              shouldSendNotification && shipmentsService.externalShipmentErrorNotification(shipmentId);
              messageDialogApi.close(dispatch, getState)();
            };

            const noSensorIntegrationFunc = () => {
              api
                .markShipmentAsReceived(
                  dispatch,
                  getState
                )({ selectedRowsData, skipExternalSensors: true, reloadParentComponent, successCallback })
                .then(({ success }) => {
                  if (success) {
                    successCallback?.({ sSelectedRowsData: selectedRowsData, parentComponent: reloadParentComponent });
                  }
                });
            };

            const messageDialogDescriptor = getSensorIntegrationErrorMessageDescriptor(response, retryFunc, closeFunc, noSensorIntegrationFunc);

            messageDialogApi.open(dispatch, getState)(messageDialogDescriptor);
            return { success: false };
          }

          if (errorCode === 'MAT_5545014') {
            gridApi.reload(dispatch, getState)();
          }
          
          messageDialogApi.responseError(dispatch, getState)(response);
          return { success: false };
        }

        if (reloadParentComponent) {
          reloadParentComponent();
        }

        return { success: true };
      })
      .catch((error) => {
        gridApi.setBusy(false)(dispatch, getState);
        console.error('Mark shipment as received failed', error);
        return { success: false };
      });
  };
};

api.deleteShipmentConfirmationDialog = function(dispatch, getState) {
  return function(data) {
    let confirmationConfig = {
      submitHandler: () => api.deleteShipment(dispatch, getState)(data)
    }
    messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig);
  }
};

api.deleteShipment = function(dispatch, getState) {
  return function({selectedRowsData, reloadParentComponent}) {
    gridApi.setBusy(true)(dispatch, getState);

    messageDialogApi.close(dispatch, getState)();

    let locationId = locationPageApi.getLocationId(dispatch, getState)();
    let shipmentId = selectedRowsData?.get(0)?.id || null;

    shipmentsService.deleteShipment(shipmentId, locationId).then((response) => {
      gridApi.setBusy(false)(dispatch, getState);

      if (!Network.isResponseValid(response)) {
        console.error('Delete Shipment failed', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }

      if (reloadParentComponent) {
        reloadParentComponent();
      }

      return {success: true};
    }).catch((error) => {
      gridApi.setBusy(false)(dispatch, getState);
      console.error('Delete Shipment failed', error);
      return {success: false};
    });
  }
};


/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS

function getSensorIntegrationErrorMessageDescriptor(response, retryFunc, closeFunc, noSensorIntegrationFunc) {
  const allLabels = createLabelHelper('');
  const dialogLabels = createLabelHelper('mat.dialog.');
  const sensorIntegrationErrorLabels = createLabelHelper('mat.locationpage.view.shipments.sensorIntegrationError.dialog.');

  const title = sensorIntegrationErrorLabels.get('title');

  const message = allLabels.get(
    response?.applicationResponseStatus?.errorCode,
    sensorIntegrationErrorLabels.get('defaultMessage'),
    response?.applicationResponseStatus?.errors?.mainError?.params
  );

  const retryAction = () => {
    retryFunc();
    closeFunc(false);
  }

  const noSensorIntegrationAction = () => {
    noSensorIntegrationFunc();
    closeFunc();
  }

  let buttons = [
    { id: 'close', text: dialogLabels.get('cancel'), action: closeFunc },
    { id: 'retry', text: dialogLabels.get('retry'), action: retryAction, bsStyle: 'primary', style: { marginRight: '20px' } },
    {
      id: 'noSensorIntegration',
      text: sensorIntegrationErrorLabels.get('btn.noSensorIntegration'),
      action: noSensorIntegrationAction,
      bsStyle: 'primary',
    },
  ];

  let children = <MessageDialog.MessageArea text={message} />;
  return { title, children, buttons, type: 'error' };
}